import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', justifyContent: 'center', alignItems: 'center',
          height: '100vh', background: '#f8fafc', fontFamily: 'system-ui, sans-serif',
        }}>
          <div style={{
            textAlign: 'center', padding: '48px', background: '#fff',
            borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
            maxWidth: '440px',
          }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
            <h2 style={{ margin: '0 0 8px', color: '#0f172a', fontSize: '1.25rem' }}>
              Something went wrong
            </h2>
            <p style={{ color: '#64748b', fontSize: '0.9rem', lineHeight: 1.5, margin: '0 0 24px' }}>
              The application encountered an unexpected error. Please try refreshing the page.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: 'linear-gradient(135deg, #004aad, #0062e6)', color: '#fff',
                border: 'none', padding: '10px 28px', borderRadius: '10px',
                fontSize: '0.9rem', fontWeight: 600, cursor: 'pointer',
              }}
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
